import React from "react";
import ReactDOM from "react-dom/client";
import { Buffer } from "buffer";
import App from "./App.tsx";
import { ErrorBoundary } from "./ui/ErrorBoundary.tsx";
import "leaflet/dist/leaflet.css";
// Split from one 2601-line styles.css into src/styles/ by section (see
// project_evalhid_code_audit.md's "large file" pass) — plain text
// reorganization, no selectors/values touched. Order matters: two rules of
// equal specificity resolve by SOURCE order, so these must stay in the same
// sequence the sections had in the original file.
import "./styles/base.css";
import "./styles/landing.css";
import "./styles/workspace.css";
import "./styles/popovers.css";
import "./styles/resultsPanel.css";
import "./styles/catalogTable.css";
import "./styles/wizard.css";
import "./styles/editBar.css";
import "./styles/editPanel.css";
import "./styles/canvas.css";
import "./styles/dialog.css";
import "./styles/help.css";

// mdb-reader (lectura del .ehd) usa Buffer, que no es global en el navegador
if (!(globalThis as unknown as { Buffer?: unknown }).Buffer) {
  (globalThis as unknown as { Buffer: unknown }).Buffer = Buffer;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
